import React, {useEffect, useState, useCallback, useRef} from 'react'
import {GoogleMap, useLoadScript, Marker} from '@react-google-maps/api'
const libraries = ['places'] as any
const mapContainerStyle = {
  width: '100vw',
  height: '100vh',
}

const GoogleMapComponent2 = ({
  latitude,
  longitude,
  onSelectLocation,
}: {
  latitude: any
  longitude: any
  onSelectLocation: any
}) => {
  const [selectedPlace, setSelectedPlace] = useState({
    lat: latitude || 41.3113642,
    lng: longitude || 69.28267819999999,
  }) as any
  const markerRef = useRef(null) as any
  const mapRef = useRef(null) as any

  useEffect(() => {
    if (latitude && longitude) {
      const newLocation:any = {lat: latitude, lng: longitude}
      setSelectedPlace(newLocation)
      if (mapRef.current) {
        mapRef.current.panTo(newLocation)
      }
      animateMarker()
    }
  }, [latitude, longitude])

  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_KEY!,
    libraries,
  })

  const onMapClick = useCallback((event :any) => {
    const newMarker = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    }

    setSelectedPlace(newMarker)
    if (mapRef.current) {
      mapRef.current.panTo(newMarker)
    }
    animateMarker()
    reverseGeocode(newMarker, newMarker)
  }, [])

  const onMarkerDragEnd = useCallback((event :any) => {
    const newPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    }

    setSelectedPlace(newPosition)
    if (mapRef.current) {
      mapRef.current.panTo(newPosition)
    }
    animateMarker()
    reverseGeocode(newPosition, newPosition)
  }, [])

  const animateMarker = () => {
    if (markerRef.current) {
      markerRef.current.setAnimation(window.google.maps.Animation.BOUNCE)
      setTimeout(() => {
        markerRef.current.setAnimation(null)
      }, 200) // Bounce animation duration
    }
  }

  const extractLocationDetails = (result: any, exactCoordinates: any) => {
    const addressComponents = result.address_components
    const locationDetails = {
      location: result.formatted_address,
      state: getAddressComponent(addressComponents, 'administrative_area_level_1'),
      city: getAddressComponent(addressComponents, 'locality'),
      country: getAddressComponent(addressComponents, 'country'),
      latitude: exactCoordinates.lat,
      longitude: exactCoordinates.lng,
    }
    return locationDetails
  }

  const reverseGeocode = async (marker: any, exactCoordinates: any) => {
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({location: marker}, (results:any, status) => {
      if (status === 'OK') {
        let locationDetails:any = {
          location: 'Unknown location',
          state: '',
          city: '',
          country: '',
          latitude: exactCoordinates.lat,
          longitude: exactCoordinates.lng,
          plusCode: '',
        }

        for (let i = 0; i < results.length; i++) {
          if (results[i].plus_code && results[i].plus_code.global_code) {
            locationDetails = extractLocationDetails(results[i], exactCoordinates)
            locationDetails.plusCode = results[i].plus_code.global_code
            break
          } else if (i === 0) {
            // Use the first result if no plus code is found
            locationDetails = extractLocationDetails(results[i], exactCoordinates)
          }
        }
        onSelectLocation(locationDetails)
      } else {
        onSelectLocation({
          location: 'Unknown location',
          state: '',
          city: '',
          country: '',
          latitude: exactCoordinates.lat,
          longitude: exactCoordinates.lng,
        })
      }
    })
  }

  const getAddressComponent = (addressComponents:any, type:any) => {
    const component = addressComponents.find((component:any) => component.types.includes(type))
    return component ? component.long_name : ''
  }

  if (loadError) {
    return <div>Error loading maps</div>
  }

  if (!isLoaded) {
    return <div>Loading maps</div>
  }

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={10}
      center={selectedPlace}
      onClick={onMapClick}
      mapContainerClassName='w-100 h-400px shadow-sm rounded-4'
      onLoad={(map:any) => (mapRef.current = map)}
    >
      <Marker
        position={selectedPlace}
        draggable={true}
        onDragEnd={onMarkerDragEnd}
        onLoad={(marker) => (markerRef.current = marker)}
      />
    </GoogleMap>
  )
}

export default GoogleMapComponent2
